<template>
    <main>
        <loader :loading="true" v-if="loading"></loader>
        <h1 class="title">{{ $t("brand.navigation.notificationList") }}</h1>
        <div class="create-list">
            <div><TextInputBloc :label="$t('notificationList.createNewList')" v-model="newNotificationList.name"> </TextInputBloc><br /></div>
            <div class="">
                <SelectBloc
                    :value="newNotificationList.applicationId"
                    @change="newNotificationList.applicationId = parseInt($event)"
                    :required="true"
                    :options="applicationOptions"
                    :label="'Application'"
                />
                <ClientColorButton :disabled="!newNotificationList.name" @click="createNotificationList">{{ $t("common.create") }}</ClientColorButton>
            </div>
        </div>
        <div v-for="list in notificationLists" :key="list.id">
            <NotificationListDetail :users="users" :list="list" :zones="zones" :applications="applicationOptions" />
        </div>
    </main>
</template>

<script>
import notificationListService from "@/services/notificationList";
import NotificationListDetail from "./NotificationListDetail";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import ClientColorButton from "@/components/ui/ClientColorButton";
import brandService from "@/services/brand";
import { mapActions, mapGetters } from "vuex";
import { EventBus, EVENTS } from "./EventBus";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import zonesService from "@/services/zone";
import SelectBloc from "@/components/ui/Form/SelectBloc";

export default {
    components: { SelectBloc, NotificationListDetail, loader, ClientColorButton, TextInputBloc },
    props: {
        brandId: Number
    },
    mixins: [TryLoad],
    data() {
        return {
            notificationLists: [],
            notificationListsToBeDeleted: [],
            newNotificationList: {
                name: "",
                applicationId: ""
            },
            users: [],
            brand: null,
            zones: []
        };
    },
    computed: {
        ...mapGetters("functionality", {
            getAllApplications: "getAllApplications"
        }),
        applications() {
            return (
                (this.brand &&
                    this.brand.brandAccesses.map(brandAccess => {
                        let fullApp = this.getAllApplications.filter(app => app.id === brandAccess.application)[0];
                        return {
                            id: brandAccess.application,
                            name: this.getTranslate(fullApp.terms.name)
                        };
                    })) ||
                []
            );
        },
        applicationOptions() {
            return this.applications.map(app => {
                return { value: app.id, label: app.name };
            });
        }
    },
    mounted() {
        EventBus.$on(EVENTS.UPDATE_NOTIFICATION_LIST, payLoad => {
            this.updateNotificationList(payLoad);
        });
        EventBus.$on(EVENTS.DELETE_NOTIFICATION_LIST, payLoad => {
            this.deleteNotificationList(payLoad);
        });
    },
    async created() {
        if (!this.getAllApplications) {
            await this.tryLoad(() => this.findAllApplications());
        }

        const [notificationLists, fetchedUsers, brandResponse, zones] = await this.tryLoad(() =>
            Promise.all([
                notificationListService.getAllByBrandId(this.brandId),
                notificationListService.getNotificationListUsers(this.brandId),
                brandService.getBrand(this.brandId),
                zonesService.getAll()
            ])
        );
        this.notificationLists = notificationLists;
        this.users = this.sortUsers(fetchedUsers);
        // Handle both array response and paginated {data: [...]} response
        this.brand = Array.isArray(brandResponse) ? brandResponse[0] : brandResponse.data ? brandResponse.data[0] : brandResponse;
        this.zones = zones;
    },
    methods: {
        ...mapActions("functionality", {
            findAllApplications: "findAllApplications"
        }),
        async createNotificationList() {
            let newList = await this.tryLoad(() =>
                notificationListService.create(
                    { name: this.newNotificationList.name, application: { id: this.newNotificationList.applicationId } },
                    this.brandId
                )
            );
            this.dialogSuccess(this.$t("saved"));
            this.notificationLists.push(newList);
            this.newNotificationList.name = "";
        },
        updateNotificationLists(notificationLists) {
            this.notificationLists = notificationLists;
            this.setIsDirty(true);
        },
        updateNotificationList(notificationList) {
            this.notificationLists = this.notificationLists.map(listItem => {
                if (listItem.id === notificationList.id) {
                    return notificationList;
                } else {
                    return listItem;
                }
            });
            this.setIsDirty(true);
        },
        async saveNotificationLists() {
            const promises = [];
            // update list(s)
            for (const list of this.notificationLists) {
                promises.push(notificationListService.update(list, this.brandId));
            }
            // delete list(s)
            for (const list of this.notificationListsToBeDeleted) {
                promises.push(notificationListService.delete(list.id));
            }
            await this.tryLoad(() => Promise.all(promises));
            this.notificationListsToBeDeleted = [];
            this.dialogSuccess(this.$t("saved"));
            this.setIsDirty(false);
        },
        deleteNotificationList(list) {
            // remove to-be-deleted notification list from array
            this.notificationLists = this.notificationLists.filter(listItem => listItem.id !== list.id);
            this.notificationListsToBeDeleted.push(list);
            this.setIsDirty(true);
        },
        sortUsers(users) {
            return users.sort((el1, el2) => {
                // sort users by last name
                return el1.lastname.toLowerCase() > el2.lastname.toLowerCase();
            });
        },
        setIsDirty(value) {
            EventBus.$emit(EVENTS.UPDATE_IS_DIRTY, value);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/themes";
@import "../../../assets/css/media";
.title {
    font-family: "Oswald", sans-serif;
    font-size: 30px;
    text-transform: uppercase;
}
.create-list {
    margin-bottom: 30px;
    border-bottom: black solid 1px;
    border-top: black solid 1px;
    padding: 10px 0;
    label {
        width: 200px;
    }
    .inner {
        display: flex;
        justify-content: space-around;
    }
}
</style>



// WEBPACK FOOTER //
// NotificationLists.vue?27aab30c